Application.QrCode.Contact = {
    ui: {
        container: '.js-qr-codes-contact',
        select: {
            container: '.form-control_select',
            select: '.form-control__input',
            input: '.form-control__sync-hidden',
        }
    },
    ready: function () {

        if (!$(this.ui.container).length){
            return;
        }

        this.bind();

    },
    bind: function(){

        var self = this;

        // sync select input
        $(document).on('change', this.ui.select.select, function(event){
            self.updateCountrySelect(this);
        });
        // init
        $(this.ui.select.select).each(function(){
            self.updateCountrySelect(this);
        });

    },
    updateCountrySelect: function(select){

        var $select = $(select);
        var $input = $select.closest(this.ui.select.container).find(this.ui.select.input);

        $input.val($select.val());

    }
}